module.exports = __webpack_public_path__ + "img/verify-hk.7e9844e3.png";